import { Button } from "../ui/button";

export const TopPageRegisterButton = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className: string;
}) => {
  return (
    <Button className={className} onClick={onClick}>
      登録・ログイン
    </Button>
  );
};
